import React from 'react';
import styles from './Offscreen.module.scss';

interface OffscreenProps {
  as?: 'span'| 'div' | 'legend' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
  children: React.ReactNode;
}

export function Offscreen({ as: As = 'span', children, ...props }: OffscreenProps) {
  return (
    <As className={ styles.visuallyHidden } {...props}>{ children }</As>
  )
}
